import { isDevelopment } from "@biblioteksentralen/utils";

export type LCVersionResponse = {
  version: string;
};

export const libryContentVersion =
  process.env.SANITY_STUDIO_COMMIT_SHA?.slice(0, 7) ?? (isDevelopment() ? "development" : "unknown");
